import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import useConfig from '../../hooks/useConfig';
var cls = 'search-bar';
var SearchBar = function SearchBar(_ref) {
  var _onClick = _ref.onClick,
    id = _ref.id,
    pid = _ref.pid,
    render = _ref.render,
    className = _ref.className;
  var _useConfig = useConfig(),
    createNamespace = _useConfig.createNamespace,
    prefixCls = _useConfig.prefixCls;
  var classes = classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls, prefixCls), className);
  return _jsx("div", Object.assign({
    className: classes,
    onClick: function onClick() {
      return _onClick === null || _onClick === void 0 ? void 0 : _onClick({
        render: render,
        pid: pid,
        componentId: id
      });
    },
    "data-componentid": id,
    "data-pid": pid
  }, {
    children: _jsxs("div", Object.assign({
      className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-input", prefixCls)),
      tabIndex: 0
    }, {
      children: [_jsx("img", {
        alt: "",
        className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-icon", prefixCls)),
        src: "https://baleen-cdn-g.bybieyang.com/by/lego/2c609edd0c03d73f30e5d09d17acda79.png"
      }), _jsx("div", Object.assign({
        className: classnames(createNamespace === null || createNamespace === void 0 ? void 0 : createNamespace(cls + "-placeholder", prefixCls))
      }, {
        children: "search"
      }))]
    }))
  }));
};
SearchBar.displayName = 'SearchBar';
export default SearchBar;